import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled, { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import Spinner from "~/components-shared/Spinner";
import { Icon, Link } from "~/components-shared";
const Wrapper = styled.div`
  overflow: ${_ref => {
  let {
    $overflow
  } = _ref;
  return $overflow;
}};
  width: 100%;
  -webkit-overflow-scrolling: touch;
  border-radius: 6px;
  ${_ref2 => {
  let {
    $fontSize,
    theme
  } = _ref2;
  return $fontSize && `font-size: ${theme.typography.fontStep * $fontSize}rem`;
}};
  ${_ref3 => {
  let {
    $s,
    theme
  } = _ref3;
  return theme.spacing.resolve(theme, $s);
}};
`;
const StyledTable = styled.table`
  border-collapse: collapse;
  table-layout: auto;
  font-size: 1rem;
  width: 100%;
  word-break: initial;

  th,
  td {
    font-weight: normal;
    vertical-align: top;
    padding: ${_ref4 => {
  let {
    $size
  } = _ref4;
  switch ($size) {
    case "s":
      return "0.7rem 0.5rem";
    case "l":
      return "2rem 1rem";
    default:
      return "1.5rem 0.5rem";
  }
}};
    text-align: left;
    transition: background-color 200ms ease-in-out;

    &:first-child {
      border-left-width: 0;
    }

    &:last-child {
      border-right-width: 0;
    }

    @media (max-width: 768px) {
      padding: 0.5rem;
    }
  }

  tr:last-child td {
    border-bottom-width: 0;
  }

  tbody.row:hover td,
  tbody tr:hover td {
    background-color: rgba(0, 50, 255, 0.03);
    cursor: pointer;
  }

  thead th {
    border-top-width: 0;
  }

  th {
    color: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.text.secondary;
}};
    font-weight: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.typography.fontWeight.regular;
}};
    padding: 0 0.5rem;
  }

  tfoot td {
    color: ${_ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colors.text.secondary;
}};
    font-size: 0.8rem;
  }
`;
const Actions = styled.div`
  display: flex;
  justify-content: flex-end;

  & > * {
    margin: 0 2px;
  }
`;
const Td = styled.td`
  ${_ref8 => {
  let {
    $noHover
  } = _ref8;
  return $noHover && `background-color: transparent!important;cursor:initial!important;`;
}}
`;
const Tr = styled.tr``;
const LoadMore = styled.span`
  color: ${_ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.text.secondary;
}};
  font-weight: ${_ref10 => {
  let {
    theme
  } = _ref10;
  return theme.typography.fontWeight.semiBold;
}};
  margin: 0.1rem 0.3rem;
  display: inline-block;
`;
const Table = _ref11 => {
  let {
    children,
    tableProps,
    overflow = "auto",
    fontSize,
    size = "m",
    s,
    ...rest
  } = _ref11;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $fontSize: fontSize,
    $overflow: overflow,
    $s: s
  }, rest), /*#__PURE__*/React.createElement(StyledTable, _extends({
    $size: size
  }, tableProps), children));
};
Table.Header = _ref12 => {
  let {
    children,
    ...rest
  } = _ref12;
  return /*#__PURE__*/React.createElement("thead", rest, children);
};
Table.Body = _ref13 => {
  let {
    children,
    ...rest
  } = _ref13;
  return /*#__PURE__*/React.createElement("tbody", rest, children);
};
Table.Footer = _ref14 => {
  let {
    children,
    ...rest
  } = _ref14;
  return /*#__PURE__*/React.createElement("tfoot", rest, children);
};
Table.Tr = _ref15 => {
  let {
    children,
    ...rest
  } = _ref15;
  return /*#__PURE__*/React.createElement(Tr, rest, children);
};
Table.Th = _ref16 => {
  let {
    children,
    center = false,
    middle = false,
    width = "initial",
    sort,
    sortBy,
    onSort,
    colSpan,
    ...rest
  } = _ref16;
  const theme = useTheme();
  let content = children;
  if (sort && sortBy && typeof onSort === "function") {
    const sorted = sortBy.includes(sort);
    const asc = sort.includes("ASC");
    const index = sortBy.findIndex(value => value === sort);
    const sortValue = index >= 0 ? sortBy[index + 1] || sortBy[0] : sortBy[0];
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
      onClick: () => onSort(sortValue),
      color: theme.colors.text.secondary,
      weight: sorted ? "bold" : undefined,
      underline: true
    }, children), sorted && (asc ? /*#__PURE__*/React.createElement(Icon, {
      src: "chevron"
    }) : /*#__PURE__*/React.createElement(Icon, {
      src: "chevron",
      rotate: 180
    })));
  }
  return /*#__PURE__*/React.createElement("th", _extends({
    style: {
      textAlign: center ? "center" : "left",
      verticalAlign: middle ? "middle" : "top",
      width
    },
    colSpan: colSpan
  }, rest), content);
};
Table.Td = _ref17 => {
  let {
    children,
    colSpan = 1,
    center = false,
    middle = false,
    noHover = false,
    ...rest
  } = _ref17;
  return /*#__PURE__*/React.createElement(Td, _extends({
    colSpan: colSpan,
    $noHover: noHover,
    style: {
      textAlign: center ? "center" : "left",
      verticalAlign: middle ? "middle" : "top"
    }
  }, rest), children);
};
Table.Actions = _ref18 => {
  let {
    children,
    ...rest
  } = _ref18;
  return /*#__PURE__*/React.createElement(Actions, rest, children);
};
Table.LoadMore = _ref19 => {
  let {
    children,
    colSpan,
    isLoading,
    ...rest
  } = _ref19;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Table.Tr, null, /*#__PURE__*/React.createElement(Table.Td, _extends({
    center: true,
    colSpan: colSpan
  }, rest), isLoading ? /*#__PURE__*/React.createElement(Spinner, {
    scale: 4
  }) : /*#__PURE__*/React.createElement(LoadMore, null, t("common.actions.loadMore"))));
};
export default Table;